import Rebase from 're-base';

const base = Rebase.createClass({
	apiKey: "AIzaSyAkpsoxPVMWSvoL8eYmrr7IZUOnU2bmokY",
	authDomain: "catch-of-the-day-a8032.firebaseapp.com",
	databaseURL: "https://catch-of-the-day-a8032.firebaseio.com",
});

export default base;


/** WEBPACK FOOTER **
 ** ./src/base.js
 **/